// src/pages/WhatWeDo.js
import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import "./WhatWeDo.css";

const WhatWeDo = () => {
  return (
    <main className="what-we-do">
      <Seo
        title="What We Do | Clean Sweeps"
        description="See what Clean Sweeps delivers for Shopify sweepstakes: purchase-based entry rules, AMOE compliance, referrals, and storefront entry widgets."
        path="/what-we-do"
        image="/og/what-we-do.png"
        imageAlt="Clean Sweeps features overview"
      />
      <header className="what-we-do__hero">
        <p className="page-eyebrow">What we do</p>
        <h1>Everything Clean Sweeps delivers for Shopify sweepstakes.</h1>
        <p className="what-we-do__lead">
          Configure purchase-based entry rules, manage sweepstakes and entrants,
          support AMOE compliance, and show entries across your storefront.
        </p>
      </header>

      <section className="what-we-do__section">
        <div className="what-we-do__header">
          <h2>Sweepstakes setup</h2>
          <p>
            Control how entries are earned with flexible rules that match your
            promotional strategy.
          </p>
        </div>
        <ul className="what-we-do__list">
          <li>Entries-per-$ with rounding</li>
          <li>Spend-X get-Y bonus entries</li>
          <li>Scheduled bonus periods</li>
          <li>Product eligibility</li>
          <li>Product bonus entries</li>
          <li>Product multipliers</li>
          <li>Order multipliers</li>
          <li>Discount-code bonuses</li>
          <li>Membership tag bonuses</li>
        </ul>
      </section>

      <section className="what-we-do__section">
        <div className="what-we-do__header">
          <h2>Admin tools</h2>
          <p>Manage entrants and winners with built-in admin workflows.</p>
        </div>
        <ul className="what-we-do__list">
          <li>Entrants management</li>
          <li>Bulk CSV upload (upload entrants in bulk)</li>
          <li>Winner selection</li>
          <li>Export winners to CSV</li>
          <li>Email notifications (send customers post-purchase entry confirmations)</li>
        </ul>
      </section>

      <section className="what-we-do__section">
        <div className="what-we-do__header">
          <h2>Compliance (AMOE)</h2>
          <p>
            Provide an Alternate Method of Entry with an AMOE portal that meets
            compliance needs.
          </p>
        </div>
        <ul className="what-we-do__list">
          <li>AMOE portal with online form</li>
          <li>Optional mail-in approval workflow</li>
        </ul>
      </section>

      <section className="what-we-do__section">
        <div className="what-we-do__header">
          <h2>Referrals &amp; affiliates</h2>
          <p>Capture and track referrals from checkout and beyond.</p>
        </div>
        <ul className="what-we-do__list">
          <li>Referral codes</li>
          <li>Checkout referral capture</li>
        </ul>
      </section>

      <section className="what-we-do__section">
        <div className="what-we-do__header">
          <h2>Widgets &amp; Extensions</h2>
          <p>Show entries everywhere shoppers look.</p>
        </div>
        <div className="what-we-do__widgets">
          <article className="widget-card">
            <h3>Product Entry Widget</h3>
            <p className="widget-card__meta">Appears on product pages.</p>
            <p>Shows entries earned for the selected product.</p>
          </article>

          <article className="widget-card">
            <h3>Cart Widget</h3>
            <p className="widget-card__meta">Appears in the cart.</p>
            <p>Shows entries earned before checkout.</p>
          </article>

          <article className="widget-card">
            <h3>Checkout Product Entries (line item)</h3>
            <p className="widget-card__meta">Appears in checkout line items.</p>
            <p>Shows entries tied to each product in the order.</p>
          </article>

          <article className="widget-card">
            <h3>Checkout Total Summary</h3>
            <p className="widget-card__meta">Appears in checkout summary.</p>
            <p>Shows total entries for the order.</p>
          </article>

          <article className="widget-card">
            <h3>Thank-You Page Summary</h3>
            <p className="widget-card__meta">Appears on the thank-you page.</p>
            <p>Shows entries earned after purchase.</p>
          </article>

          <article className="widget-card">
            <h3>Account Widget</h3>
            <p className="widget-card__meta">Appears in customer accounts.</p>
            <p>Shows entries associated with the customer.</p>
          </article>

          <article className="widget-card">
            <h3>Guest Email Lookup Widget</h3>
            <p className="widget-card__meta">Appears in the guest lookup flow.</p>
            <p>Shows entries for guest checkouts by email.</p>
          </article>

          <article className="widget-card">
            <h3>Countdown Bonus Banner/Widget</h3>
            <p className="widget-card__meta">Appears on storefront pages.</p>
            <p>Shows a countdown tied to bonus entry periods.</p>
          </article>

          <article className="widget-card">
            <h3>AMOE Form</h3>
            <p className="widget-card__meta">Appears in the AMOE portal.</p>
            <p>Collects online Alternate Method of Entry submissions.</p>
          </article>
        </div>
      </section>

      <section className="what-we-do__section">
        <div className="what-we-do__header">
          <h2>How to run a sweepstakes on Shopify</h2>
          <p>
            Follow our step-by-step guide to plan, launch, and manage
            sweepstakes with a Shopify sweepstakes app.
          </p>
        </div>
        <div className="what-we-do__cta">
          <Link to="/how-to-run-a-sweepstakes" className="btn btn--primary">
            Read the guide
          </Link>
          <a
            href="https://apps.shopify.com/clean-sweeps"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--ghost"
          >
            Install Clean Sweeps
          </a>
        </div>
      </section>
    </main>
  );
};

export default WhatWeDo;
